import script from "./StationDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./StationDetail.vue?vue&type=script&setup=true&lang=js"

import "./StationDetail.vue?vue&type=style&index=0&id=c530da16&lang=css"

const __exports__ = script;

export default __exports__